export const PRICE_FIXED_FROM = 8;

export const UNLIMITED_QUANTITY = 100;

function rangeOptions(from, to) {
  return Array.from({ length: to - from + 1 }, (_, i) => ({
    label: String(from + i),
    value: from + i,
  }));
}

const UNLIMITED_OPTION = {
  label: `${PRICE_FIXED_FROM}+`,
  value: UNLIMITED_QUANTITY,
};

export const SPA_RESOURCE_OPTIONS = [
  ...rangeOptions(0, PRICE_FIXED_FROM - 1),
  UNLIMITED_OPTION,
];

export const STAFF_OPTIONS = {
  general: rangeOptions(1, 10),
  hotel: [...rangeOptions(1, PRICE_FIXED_FROM - 1), UNLIMITED_OPTION],
};
